var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 116,
    viewBox: "0 0 121 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_1963_45187)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 26,
    width: 61,
    height: 46,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.116 50H51.88L49.996 46.784H48.016V50H46.9V41.6H50.26C50.98 41.6 51.596 41.856 52.108 42.368C52.62 42.872 52.876 43.484 52.876 44.204C52.876 44.748 52.712 45.244 52.384 45.692C52.048 46.148 51.632 46.464 51.136 46.64L53.116 50ZM50.26 42.644H48.016V45.776H50.26C50.676 45.776 51.028 45.624 51.316 45.32C51.612 45.016 51.76 44.644 51.76 44.204C51.76 43.764 51.612 43.396 51.316 43.1C51.028 42.796 50.676 42.644 50.26 42.644ZM59.6121 47.48H54.5841C54.6881 48.008 54.9321 48.424 55.3161 48.728C55.7001 49.024 56.1801 49.172 56.7561 49.172C57.5481 49.172 58.1241 48.88 58.4841 48.296L59.3721 48.8C58.7801 49.704 57.9001 50.156 56.7321 50.156C55.7881 50.156 55.0121 49.86 54.4041 49.268C53.8121 48.66 53.5161 47.904 53.5161 47C53.5161 46.088 53.8081 45.336 54.3921 44.744C54.9761 44.144 55.7321 43.844 56.6601 43.844C57.5401 43.844 58.2561 44.156 58.8081 44.78C59.3681 45.388 59.6481 46.132 59.6481 47.012C59.6481 47.164 59.6361 47.32 59.6121 47.48ZM56.6601 44.828C56.1081 44.828 55.6441 44.984 55.2681 45.296C54.9001 45.608 54.6721 46.032 54.5841 46.568H58.5921C58.5041 46.016 58.2841 45.588 57.9321 45.284C57.5801 44.98 57.1561 44.828 56.6601 44.828ZM65.8332 45.032V41.6H66.8772V50H65.8332V48.968C65.3212 49.76 64.5652 50.156 63.5652 50.156C62.7172 50.156 62.0012 49.852 61.4172 49.244C60.8252 48.628 60.5292 47.88 60.5292 47C60.5292 46.128 60.8252 45.384 61.4172 44.768C62.0092 44.152 62.7252 43.844 63.5652 43.844C64.5652 43.844 65.3212 44.24 65.8332 45.032ZM63.6972 49.148C64.3052 49.148 64.8132 48.944 65.2212 48.536C65.6292 48.112 65.8332 47.6 65.8332 47C65.8332 46.392 65.6292 45.884 65.2212 45.476C64.8132 45.06 64.3052 44.852 63.6972 44.852C63.0972 44.852 62.5932 45.06 62.1852 45.476C61.7772 45.884 61.5732 46.392 61.5732 47C61.5732 47.6 61.7772 48.112 62.1852 48.536C62.5932 48.944 63.0972 49.148 63.6972 49.148ZM73.5518 49.244C72.9438 49.852 72.1958 50.156 71.3078 50.156C70.4198 50.156 69.6718 49.852 69.0638 49.244C68.4558 48.636 68.1518 47.888 68.1518 47C68.1518 46.112 68.4558 45.364 69.0638 44.756C69.6718 44.148 70.4198 43.844 71.3078 43.844C72.1958 43.844 72.9438 44.148 73.5518 44.756C74.1678 45.372 74.4758 46.12 74.4758 47C74.4758 47.88 74.1678 48.628 73.5518 49.244ZM71.3078 49.136C71.9078 49.136 72.4118 48.932 72.8198 48.524C73.2278 48.116 73.4318 47.608 73.4318 47C73.4318 46.392 73.2278 45.884 72.8198 45.476C72.4118 45.068 71.9078 44.864 71.3078 44.864C70.7158 44.864 70.2158 45.068 69.8078 45.476C69.3998 45.884 69.1958 46.392 69.1958 47C69.1958 47.608 69.3998 48.116 69.8078 48.524C70.2158 48.932 70.7158 49.136 71.3078 49.136Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0056 80.0064C53.8024 80.917 55.219 80.917 56.0159 80.0064L63.0214 72H46L53.0056 80.0064Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_1963_45187",
    x: 0,
    y: 0,
    width: 121,
    height: 115.727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1963_45187"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1963_45187",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.6125 0 0 0 0 0.6125 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1963_45187"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.17b0eb17066f13c8539e8030961a3ac7.svg";
export { ForwardRef as ReactComponent };